/** Matches backend userModel loginType enum for OAuth providers. */
export const SOCIAL_LOGIN_TYPES = ['google', 'facebook', 'twitter'];

export function isSocialLoginType(loginType) {
  return Boolean(loginType && SOCIAL_LOGIN_TYPES.includes(loginType));
}
